<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userSignup" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Name" prop="fullName">
            <el-input v-model="form.fullName" placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item label="Department" prop="departmentId">
            <el-select v-model="form.departmentId" placeholder="Select Department">
              <el-option v-for="department in filteredDepartments" :key="department.id" :label="department.name"
                :value="department.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Username" prop="username">
            <el-input v-model="form.username" placeholder="Username"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password" prop="passwordConf">
            <el-input type="password" v-model="form.passwordConf" placeholder="Confirm Password"></el-input>
          </el-form-item>
          <el-form-item label="Email Address">
            <el-input v-model="form.email" placeholder="Email Address"></el-input>
          </el-form-item>
          <el-form-item label="Phone">
            <el-input v-model="form.phone" placeholder="Phone"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="createUser">Create User</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';
import extend from 'lodash/extend';
import filter from 'lodash/filter';
import trim from 'lodash/trim';
import {
  Required, Username, Password, GenericDoubleBlindValidation,
} from '@/util/formValidators';
import User from '@/model/User';
import api from '@/api';

const defaultFormData = () => ({
  fullName: null,
  departmentId: null,
  username: null,
  password: null,
  passwordConf: null,
  email: null,
  phone: null,
});

export default {
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      form: defaultFormData(),
      rules: {
        fullName: [Required],
        departmentId: [{ trigger: 'change', ...Required }],
        username: [Required, Username],
        password: [Required, Password],
        passwordConf: [Required, { validator: this.mustMatch('form.password'), trigger: 'blur' }],
      },
    };
  },
  methods: {
    ...mapActions('Lookup', ['getDepartments']),
    createUser() {
      this.errorMessage = null;
      this.$refs.userSignup.validate((valid) => {
        if (valid) {
          // trim all values
          Object.keys(this.form).forEach((key) => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = trim(this.form[key]);
            }
          });

          const user = extend({}, User, this.form);

          this.isLoading = true;
          api.user.create(user).then((response) => {
            this.$emit('userCreated', response.data);
            this.closeDialog();
          }).catch((e) => {
            console.warn(e);
            this.errorMessage = get(e, 'response.data', 'An Error Occurred. Please try again.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.errorMessage = null;
      this.form = defaultFormData();
      this.$emit('close');
    },
    mustMatch(formItem) {
      return (...args) => {
        GenericDoubleBlindValidation(get(this, formItem), ...args);
      };
    },
  },
  computed: {
    ...mapGetters('Lookup', ['allDepartments']),
    ...mapGetters('User', ['user']),
    filteredDepartments() {
      return filter(this.allDepartments, department => department.id <= this.user.departmentId);
    },
  },
  mounted() {
    this.getDepartments();
  },
};

</script>
